module.exports = __webpack_public_path__ + "static/img/speaker.dd8cb816.png";